import { CHANGE_REQUEST_SUCCESS, SET_LOADING_FALSE, SET_REMARKS_VALUE, SET_ACTION_VALUE, CLEAR_FILTER, IS_CR_FILTER_APPLIED } from './actionTypes';

export const changeRequestReducer = (state, action) => {
    switch(action.type) {      
        case CHANGE_REQUEST_SUCCESS : 
            return {
                ...state,
                isLoading: false, 
                changeRequestDetails : action.payload.changeRequestDetails           
            }
        case SET_REMARKS_VALUE:
            return { 
                ...state, 
                changeRequestDetails : state.changeRequestDetails.map((data)=> data.header.changeRequestNumber === action.payload.changeId ? 
                {
                    ...data,
                    ["header"] : { 
                        ...data["header"],
                        approverRemarks : action.payload.remarks
                    }
                } : data),              
            }; 
        case SET_ACTION_VALUE:
            return { 
                ...state, 
                changeRequestDetails : state.changeRequestDetails.map((data)=> data.header.changeRequestNumber === action.payload.changeId ? 
                {
                    ...data,
                    ["header"] : { 
                        ...data["header"],
                        action : action.payload.action
                    }
                } : data),              
            }; 
        case SET_LOADING_FALSE:
            return {
                isLoading : false
            };
		case CLEAR_FILTER: 
					return {
						...state,
						isClearFilter: action.payload.isClearFilter,
						isCrFilterApplied: false
					};
		case IS_CR_FILTER_APPLIED: 
					return {
						...state,
						isCrFilterApplied: action.payload.isCrFilterApplied
					};
        default : 
            return state;   
    }
}
